/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeeMessageRecipient } from './EmployeeMessageRecipient';
import {
    EmployeeMessageRecipientFromJSON,
    EmployeeMessageRecipientFromJSONTyped,
    EmployeeMessageRecipientToJSON,
    EmployeeMessageRecipientToJSONTyped,
} from './EmployeeMessageRecipient';

/**
 * 
 * @export
 * @interface ListEmployeeMessageRecipientsResponse
 */
export interface ListEmployeeMessageRecipientsResponse {
    /**
     * 
     * @type {Array<EmployeeMessageRecipient>}
     * @memberof ListEmployeeMessageRecipientsResponse
     */
    data: Array<EmployeeMessageRecipient>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeeMessageRecipientsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeeMessageRecipientsResponse interface.
 */
export function instanceOfListEmployeeMessageRecipientsResponse(value: object): value is ListEmployeeMessageRecipientsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeeMessageRecipientsResponseFromJSON(json: any): ListEmployeeMessageRecipientsResponse {
    return ListEmployeeMessageRecipientsResponseFromJSONTyped(json, false);
}

export function ListEmployeeMessageRecipientsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeeMessageRecipientsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeMessageRecipientFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeeMessageRecipientsResponseToJSON(json: any): ListEmployeeMessageRecipientsResponse {
      return ListEmployeeMessageRecipientsResponseToJSONTyped(json, false);
  }

  export function ListEmployeeMessageRecipientsResponseToJSONTyped(value?: ListEmployeeMessageRecipientsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeMessageRecipientToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

